<script setup>
    import {computed} from "vue";
    import {Method} from "@inertiajs/inertia";

    const props = defineProps({
        type: {
            type: String,
            default: 'submit',
        },

        method: {
            type: String,
            default: Method.GET
        },

        link: {
            type: String,
            default: ''
        },

        disabled: {
            type: Boolean,
            default: false,
            required: false,
        }
    });

    const bType = computed(() => {
        if(props.type === 'link') { return 'button'; }

        return props.type;
    });
</script>

<template>
    <button v-if="!disabled"
        :type="bType"
        class="button"
        @click="() => {
            if(type === 'link') {
                $inertia.visit(link, {
                    method: method
                })
            }
        }"
    >
        <slot />
    </button>

    <div v-else class="button" data-disabled="true"><slot/></div>
</template>
